/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Age_6mto2yInputs */

const en_us2_bodymap_age_6mto2y = /** @type {(inputs: Bodymap_Age_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 months to 2 years ago`)
};

const pt_br2_bodymap_age_6mto2y = /** @type {(inputs: Bodymap_Age_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há 6 meses a 2 anos`)
};

const es_419_bodymap_age_6mto2y = /** @type {(inputs: Bodymap_Age_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace 6 meses a 2 años`)
};

const pt_pt2_bodymap_age_6mto2y = /** @type {(inputs: Bodymap_Age_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há 6 meses a 2 anos`)
};

const fr_fr2_bodymap_age_6mto2y = /** @type {(inputs: Bodymap_Age_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il y a 6 mois à 2 ans`)
};

const de_de2_bodymap_age_6mto2y = /** @type {(inputs: Bodymap_Age_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor 6 Monaten bis 2 Jahren`)
};

const it_it2_bodymap_age_6mto2y = /** @type {(inputs: Bodymap_Age_6mto2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da 6 mesi a 2 anni fa`)
};

/**
* | output |
* | --- |
* | "6 months to 2 years ago" |
*
* @param {Bodymap_Age_6mto2yInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_age_6mto2y = /** @type {((inputs?: Bodymap_Age_6mto2yInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Age_6mto2yInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_age_6mto2y(inputs)
	if (locale === "es-419") return es_419_bodymap_age_6mto2y(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_age_6mto2y(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_age_6mto2y(inputs)
	if (locale === "de-DE") return de_de2_bodymap_age_6mto2y(inputs)
	if (locale === "it-IT") return it_it2_bodymap_age_6mto2y(inputs)
	return en_us2_bodymap_age_6mto2y(inputs)
});
export { bodymap_age_6mto2y as "bodymap.age.6mto2y" }